import * as React from 'react';

import { getUserRecoveryEmail } from 'bundles/enterprise-legacy-learner-home/utils/RecoveryEmailAPIUtils';

export type RecoveryEmailData = {
  emailAddress: string;
  userId: string;
  isVerified: boolean;
};

export function useRecoveryEmail(userId?: number, orgId?: string) {
  const [recoveryEmail, setRecoveryEmail] = React.useState<RecoveryEmailData | null>(null);
  const [isRecoveryEmailLoading, setIsRecoveryEmailLoading] = React.useState<boolean>(false);
  const [recoveryEmailError, setRecoveryEmailError] = React.useState<unknown | null>(null);

  React.useEffect(() => {
    let isMounted = true;

    if (!userId) {
      setRecoveryEmail(null);
      setIsRecoveryEmailLoading(false);
      setRecoveryEmailError(null);
      return () => {
        isMounted = false;
      };
    }

    setIsRecoveryEmailLoading(true);
    getUserRecoveryEmail({ userId })
      .then((res) => {
        if (!isMounted) return;
        if ('recoveryEmail' in res) {
          setRecoveryEmail(res.recoveryEmail as RecoveryEmailData);
        } else {
          setRecoveryEmail(null);
        }
      })
      .catch((err) => {
        if (!isMounted) return;
        setRecoveryEmailError(err);
      })
      .finally(() => {
        if (!isMounted) return;
        setIsRecoveryEmailLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [userId, orgId]);

  return { recoveryEmail, isRecoveryEmailLoading, recoveryEmailError };
}

export default useRecoveryEmail;
